import { useEffect, useState } from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import SideBar from '../../components/global/SideBar';
import './index.css';
import SpecialistPage from '../../components/specialists/SpecialistPage';
import { fetchPartnersOfType } from '../../services/specialist.service';
import type { PartnerResponse } from '../../services/schedule.service';
import { Loader } from '@beholos/holoscommon';

export default function PersonalTraining() {
  usePageTitle('Personal Training - Holos');
  const [partners, setPartners] = useState<PartnerResponse[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setPartners(await fetchPartnersOfType('showFitnessCoach'));
      setLoading(false);
    }
    fetchData();
  }, [])

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto">
        {loading ? <Loader/> : <SpecialistPage
          bannerClassName="md:min-h-[auto] min-h-[calc(100vh-80px)]"
          banner={{
            title: 'Personal Training',
            subtitle:
              'Agenda una sesión 100% personalizada. Tu mentor te guiará para adoptar hábitos que impulsen un estilo de vida saludable y sostenible.',
            imageUrl:
              'https://image.beholos.com/fit-in/1600x750/img/fitness-pass-v2/life/personal-training/move001.jpg',
            links: {
              text: 'Agendar Sesión',
              to: 'reservar',
            },
          }}
          section={{
            title: 'Conoce a nuestros entrenadores personales',
            description:
              'Descubre estrategias prácticas de bienestar para alcanzar un equilibrio entre tu vida personal, familiar y profesional.',
          }}
          specialists={partners.map(partner => ({
            id: partner._id,
            name: partner.name,
            slug: partner.slug,
            imageUrl: `https://image.beholos.com/600x500/filters:quality(90)${partner.otherStudioImages[0]}`,
            countryImageUrl: `https://cache.beholos.com${partner.country?.image}`,
            type: 'Personal Trainer'
          }))}
        />}
      </div>
    </div>
  );
}
